module.exports = __webpack_public_path__ + "img/banner.d772d471.jpg";